import { useCallback, useState, useEffect } from 'react'
import { getBLOKPriceInUSD } from '../utils'

const useBLOKPrice = () => {
  const [blokPrice, setBLOKPrice] = useState<number>(0);

  const fetchPriceInUSD = useCallback(async () => {
      const prices = await getBLOKPriceInUSD()
      setBLOKPrice(prices['tickers'][0]['converted_last']['usd'])
  }, [])

  useEffect(() => {
    fetchPriceInUSD()
  }, [])

  return blokPrice
}

export default useBLOKPrice
